import styled from "styled-components";

interface VolumeControlProps {
  scale: number;
  volume: number;
  onToggleVolume: () => void;
}

export const VolumeControl = ({ scale, volume, onToggleVolume }: VolumeControlProps) => {
  return (
    <Container onClick={onToggleVolume} $scale={scale} $active={volume !== 0}>
      {volume === 0 ? (
        <img src="images/audio-muted.svg" alt="audio off" width="100%" key="audio-muted" />
      ) : (
        <img src="images/audio.svg" alt="audio on" width="100%" key="audio" />
      )}
    </Container>
  );
};

const Container = styled.div<{ $scale: number; $active: boolean }>`
  transform: scale(${(props) => props.$scale});
  cursor: pointer;
  pointer-events: all;
  width: 41px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: ${(props) => props.$active ? '41px' : '25px'};
  }

  @media (orientation: portrait) {
    width: 11vw;
    height: 2.8vh;
    transform: scale(1);

    img {
      width: ${(props) => props.$active ? '11vw' : '6.9vw'};
    }
  }
`;
